import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {I18nModule} from '@spartacus/core';
import {CustomOrderOverviewComponent} from './custom-order-overview.component';
import {CustomCardModule} from '../custom-card/custom-card.module';
import {CustomIconsModule} from "../../../../../custom/icons/custom-icons.module";

@NgModule({
  imports: [
    CommonModule,
    I18nModule,
    CustomCardModule,
    CustomIconsModule,
  ],
  declarations: [CustomOrderOverviewComponent],
  exports: [CustomOrderOverviewComponent],
})
export class CustomOrderOverviewModule {}
